import { render, staticRenderFns } from "./ExchangePeriod.vue?vue&type=template&id=477a0d1d&"
import script from "./ExchangePeriod.vue?vue&type=script&lang=ts&"
export * from "./ExchangePeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports